var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyRadioCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0.25C16.4061 0.25 19.6072 1.57591 22.0156 3.98438C24.4241 6.39285 25.75 9.59394 25.75 13C25.75 16.4063 24.4241 19.6072 22.0156 22.0156C19.6072 24.4241 16.4061 25.75 13 25.75C9.59394 25.75 6.39285 24.4241 3.98438 22.0156C1.57591 19.6072 0.25 16.4063 0.25 13C0.25 9.59394 1.57591 6.39285 3.98438 3.98438C6.39285 1.57591 9.59394 0.25 13 0.25Z",
    fill: "white",
    stroke: "#878787",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 8,
    fill: "#FBFBFB",
    stroke: "#FBFBFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21C8.58172 21 5 17.4183 5 13H1C1 19.6274 6.37258 25 13 25V21ZM21 13C21 17.4183 17.4183 21 13 21V25C19.6274 25 25 19.6274 25 13H21ZM13 5C17.4183 5 21 8.58172 21 13H25C25 6.37258 19.6274 1 13 1V5ZM13 1C6.37258 1 1 6.37258 1 13H5C5 8.58172 8.58172 5 13 5V1Z",
    fill: "#585858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRadioCircle);
export default __webpack_public_path__ + "static/media/emptyRadioCircle.70881a1e.svg";
export { ForwardRef as ReactComponent };